import { VehicleOwnerT } from '../types/carriers.types'
import { CourierWorkDay } from '../types/couriers.types'

export const CourierTypes = [{ id: 1, name: 'Курьер' }]

export const CourierCarTypes = [
    { id: 1, name: 'Car', api_key: 'car' },
    { id: 2, name: 'Truck', api_key: 'truck' },
]

export const CourierPaymentTypes = [
    { id: 1, name: 'Час' },
    { id: 2, name: 'Рейс' },
    { id: 3, name: 'Стоп' },
    { id: 4, name: 'День' },
]

export const CourierStatuses = [
    { id: 1, name: 'Активен', value: '1' },
    { id: 2, name: 'Не активен', value: '0' },
]

export const CARRIER_TYPES = [
    { id: 2, name: 'Перевозчик' },
    { id: 3, name: 'Поставщик' },
    { id: 4, name: 'Поставщик курьеров' },
]

export const EMPTY_VEHICLE_OWNER: VehicleOwnerT = {
    typeId: 1,
    name: null,
    bin: null,
    contactName: null,
    address: null,
    phoneNumber: null,
    contactEmail: null,
    carModel: null,
    description: null,
    carNumber: null,
    carColor: null,
    techPassport: null,
    releaseDate: null,
}

export const VEHICLE_OWNER_OPTIONS = [
    { id: 1, name: 'ТОО' },
    { id: 2, name: 'ФИЗ ЛИЦО' },
    { id: 3, name: 'ИП' },
]

export const COURIER_DEFAULT_GRAPH: CourierWorkDay[] = [
    {
        weekday: 1,
        workTimeFrom: '08:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 2,
        workTimeFrom: '08:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 3,
        workTimeFrom: '08:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 4,
        workTimeFrom: '08:00',
        workTimeUntil: '21:00',
    },
    {
        weekday: 5,
        workTimeFrom: '08:00',
        workTimeUntil: '21:00',
    },
]
